<template>
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">{{ item.id ? 'Edit' : 'New' }} temporary leave<br>
                <!-- <div class="mt-1">
                  <div class="form-check form-check-success form-switch d-flex align-items-center">
                    <input
                      id="publishContent"
                      v-model="item.active"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="publishContent"
                    ><small class="ms-1">{{ labels['active'] }}</small></label>
                  </div>
                </div> -->
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to areas & groups list"
              @click="$router.push({name: 'researcher.administration.temporary-leaves.index'})"
            ><i data-feather="chevron-left" /></a>
            <a
              v-if="loggedUser.roles.includes('super-admin')"
              class="btn btn-icon btn-flat-secondary"
              @click="$store.dispatch('modals/toggleRequestModal', 'TemporaryLeave')"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>

      <div class="content-body content-body--senior-call">
        <div
          v-if="errors != ''"
          class="alert alert-danger mt-1 p-1"
        >
          {{ errors }}
        </div>
        <div class="row">
          <div class="col-12">
            <SearchResearcher :item="item" />

            <div class="card">
              <div
                v-b-toggle="`collapseContent`"
                class="card-header"
              >
                <h3 class="cart-title">
                  <a data-action="collapse">Content</a>
                </h3>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li>
                      <a data-action="collapse"><i data-feather="chevron-down" /></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-content collapse show">
                <b-collapse
                  :id="`collapseContent`"
                  visible
                >
                  <!-- sólo se muestra "show" si hay texto en el textarea -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-6">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.type'] }}</label>
                          <v-select
                            v-model="item.type"
                            label="name"
                            :options="types"
                            :get-option-key="option => option.id"
                          />
                        </div>
                      </div>
                      <div
                        v-if="item.type"
                        class="col-6"
                      >
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >Subtype</label>
                          <v-select
                            v-model="item.subtype"
                            label="name"
                            :options="filteredChildren"
                            :get-option-key="option => option.id"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="mb-1">
                      <label
                        for=""
                        class="form-label"
                      >{{ labels['content.reason'] }}</label>
                      <quill-editor v-model="item.reason" />
                    </div>
                    <hr>
                    <h4>Dates of the temporary leave</h4>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.begin_date'] }}</label>
                          <date-picker
                            v-model="item.begin_date"
                            format="D MMM Y"
                            value-type="format"
                            class="w-100"
                          />
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.end_date'] }}</label>
                          <date-picker
                            v-model="item.end_date"
                            format="D MMM Y"
                            value-type="format"
                            class="w-100"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>

            <IcreaRemarks
              :item="item"
            />

            <AddFile
              :id="6"
              :title="'Support documentation'"
              :type="4"
              :files="item.files_"
            />

            <InternalNotes
              :notes="item.notes"
              @saveNewNote="saveNewNote"
            />

            <AttachedForm
              :type="'TemporaryLeave'"
              :model-id="temporaryLeaveId"
            />
          </div>
        </div>

        <div class="page-actions">
          <button
            v-if="!sending"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" />
            <span class="ms-25 align-middle">Save and Exit</span>
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { BCollapse } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import InternalNotes from '@/views/back/partials/components/InternalNotes.vue'
import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select'
import IcreaRemarks from '@/views/back/partials/components/IcreaRemarks.vue'
import AddFile from '../../../admin/senior-call/components/AddFile.vue'
import SearchResearcher from '../../../partials/components/SearchResearcher.vue'
import 'vue2-datepicker/index.css'
import AttachedForm from '../../../forms/partials/AttachedForm.vue'

export default {
  components: {
    AddFile,
    SearchResearcher,
    InternalNotes,
    IcreaRemarks,
    DatePicker,
    BCollapse,
    vSelect,
    AttachedForm,
  },
  data() {
    return {
      temporaryLeaveId: this.$route.params.id,
      sending: false,
      errors: '',
    }
  },
  computed: {
    ...mapGetters({
      item: 'temporaryLeaves/item',
      loggedUser: 'auth/admin',
      types: 'temporaryLeaveTypes/items',
      labels: 'sectionLabels/itemLabels',
      user: 'users/user',
      attached: 'requestForms/attached',
      children: 'temporaryLeaveTypes/children',
    }),
    filteredChildren() {
      if (!this.item.type || !this.children) return []
      return this.children.filter(child => child.parent.id === this.item.type.id)
    },
  },
  async mounted() {
    this.$store.dispatch('sectionLabels/fetchLabels', 'administration.temporary_leave')
    this.$store.dispatch('temporaryLeaveTypes/fetchChilds')
    if (this.temporaryLeaveId) {
      await this.$store.dispatch('temporaryLeaves/fetchId', this.temporaryLeaveId)
    } else {
      await this.$store.dispatch('temporaryLeaves/cleanType')
      Vue.set(this.item, 'user', this.user)
    }

    await this.$store.dispatch('temporaryLeaveTypes/fetchActives')
  },
  watch: {
    'item.type'(newType, oldType) {
      // Clear subtype when type changes
      if (oldType && newType && oldType.id !== newType.id) {
        this.item.subtype = null
      }
    },
  },
  methods: {
    saveFiles(files) {
      this.item.files_ = files.data
    },
    async save() {
      this.sending = true
      this.item.attached_form = this.attached
      try {
        if (this.temporaryLeaveId) {
          await this.$store.dispatch('temporaryLeaves/update', { id: this.temporaryLeaveId, data: this.item })
        } else {
          await this.$store.dispatch('temporaryLeaves/create', this.item)
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.item.id) {
        Vue.swal('The temporary leave has been saved correctly!', '', 'success').then(() => {
          this.$router.push({ name: 'researcher.administration.temporary-leaves.index' })
        })
      } else {
        // Vue.swal
      }

      this.sending = false
    },
    saveNewNote(note) {
      this.item.notes.push(note)
    },
    async onSearch(search, store) {
      search.active = true
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
  },
}
</script>
